import Button from '@mui/material/Button';
import GridViewIcon from '@mui/icons-material/GridView';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ConstructionIcon from '@mui/icons-material/Construction';
import PostAddIcon from '@mui/icons-material/PostAdd';
import BadgeIcon from '@mui/icons-material/Badge';
import './General.css';
import React, {useEffect, useState} from 'react';
import {
    CDBSidebar,
    CDBSidebarContent,
    CDBSidebarHeader,
    CDBSidebarMenu,
    CDBSidebarMenuItem,
} from 'cdbreact';
import {NavLink} from 'react-router-dom';
import tonicHubLogo from "../Images/tonichub-dark.png";
import keycloak from "../../Keycloak";
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';


const SideNavBar = () => {

    const [width, setWidth] = useState(window.innerWidth);


    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const isMobile = width <= 480;

    return (
        <div
            className={`app`}
            style={{display: "flex", height: "100vh", overflow: "scroll initial"}}
            data-testid={"SideNavBar"}
        >
            <CDBSidebar
                textColor="#000000" backgroundColor="#FFFFFF"
                style={{borderRight: "6px solid #f6f6f6"}}
                className={isMobile ? "d-none" : ""}
                breakpoint={1023}>
                <CDBSidebarHeader
                    prefix={
                        <i className="fa fa-bars fa-large" style={{marginTop: "140%", color: '#FF6600'}}></i>
                    }
                >
                    <a href="/" className="text-decoration-none" style={{color: "inherit"}}>
                        <img
                            alt="Failed to load"
                            style={{
                                position: "relative",
                                width: 220,
                                marginLeft: "-20px"
                            }}
                            src={tonicHubLogo}
                        />
                    </a>
                </CDBSidebarHeader>

                <CDBSidebarContent className="sidebar-content">
                    <CDBSidebarMenu breakpoint={1023}>
                        <NavLink
                            to="/"
                            activeClassName="activeClicked"
                            className={
                                (keycloak.hasResourceRole("system_admin") ||
                                    keycloak.hasResourceRole("account_manager") ||
                                    keycloak.hasResourceRole("delivery_manager") ||
                                    keycloak.hasResourceRole("internal_user") ||
                                    keycloak.hasResourceRole("client_admin") ||
                                    keycloak.hasResourceRole("hr_admin") ||
                                    keycloak.hasResourceRole("client_recruiter") ||
                                    keycloak.hasResourceRole("client_user")
                                ) ? "d-block" : "d-none"
                            }
                        >
                            <Button href="/" style={{
                                color: '#000000',
                                fontFamily: 'Michroma',
                                fontSize: '15px',
                                textTransform: 'none',
                                width: '244px',
                                height: '45px',
                                justifyContent: 'flex-start',
                                paddingLeft: "20px"
                            }}
                                    size='Large'
                                    startIcon={<GridViewIcon style={{color: '#FF6600'}}/>}
                            >
                                <CDBSidebarMenuItem>
                                    <span style={{padding: "8px 2px 8px 0"}}>Dashboard</span>
                                </CDBSidebarMenuItem>
                            </Button>
                        </NavLink>
                        <NavLink
                            to="/ClientList"
                            activeClassName="activeClicked"
                            className={
                                (keycloak.hasResourceRole("system_admin") ||
                                    keycloak.hasResourceRole("account_manager") ||
                                    keycloak.hasResourceRole("delivery_manager") ||
                                    keycloak.hasResourceRole("client_admin")
                                )
                                    ? "d-block" : "d-none"
                            }
                        >
                            <Button href="/ClientList" style={{
                                color: '#000000',
                                fontFamily: 'Michroma',
                                fontSize: '15px',
                                textTransform: 'none',
                                width: '244px',
                                height: '45px',
                                justifyContent: 'flex-start',
                                paddingLeft: "20px"
                            }}
                                    size='Large'
                                    startIcon={<PersonOutlineIcon style={{color: '#FF6600'}}/>}
                            >
                                <CDBSidebarMenuItem>
                                    Clients
                                </CDBSidebarMenuItem>
                            </Button>
                        </NavLink>
                        <NavLink
                            to="/ServiceRequestList"
                            activeClassName="activeClicked"
                            className={
                                (keycloak.hasResourceRole("system_admin") ||
                                    keycloak.hasResourceRole("account_manager") ||
                                    keycloak.hasResourceRole("delivery_manager") ||
                                    keycloak.hasResourceRole("client_admin") ||
                                    keycloak.hasResourceRole("client_user"))
                                    ? "d-block" : "d-none"
                            }
                        >
                            <Button href="/ServiceRequestList" style={{
                                color: '#000000',
                                fontWeight: 400,
                                fontFamily: 'Michroma',
                                fontSize: '15px',
                                textTransform: 'none',
                                width: '244px',
                                height: '45px',
                                justifyContent: 'flex-start',
                                paddingLeft: "20px"
                            }}
                                    size='Large'
                                    startIcon={<ConstructionIcon style={{color: '#FF6600'}}/>}
                            >
                                <CDBSidebarMenuItem>
                                    Service Requests
                                </CDBSidebarMenuItem>
                            </Button>
                        </NavLink>

                            <NavLink
                                to="/MyCV"
                                activeClassName="activeClicked"
                                className={
                                    (keycloak.hasResourceRole("internal_user"))
                                        ? "d-block" : "d-none"
                                }

                            >
                                <Button href={"/MyCV"} style={{
                                    color: '#000000',
                                    fontWeight: 400,
                                    fontFamily: 'Michroma',
                                    fontSize: '15px',
                                    textTransform: 'none',
                                    width: '244px',
                                    height: '45px',
                                    justifyContent: 'flex-start',
                                    paddingLeft: "20px"
                                }}
                                        size='Large'
                                        startIcon={<PostAddIcon style={{color: '#FF6600'}}/>}
                                >
                                    <CDBSidebarMenuItem>
                                        My CV
                                    </CDBSidebarMenuItem>
                                </Button>
                            </NavLink>


                            <NavLink
                                to="/StaffMemberListView"
                                activeClassName="activeClicked"
                                className={
                                    (keycloak.hasResourceRole("account_manager"))
                                        ? "d-block" : "d-none"
                                }

                            >
                                <Button href={"/StaffMemberListView"} style={{
                                    color: '#000000',
                                    fontWeight: 400,
                                    fontFamily: 'Michroma',
                                    fontSize: '15px',
                                    textTransform: 'none',
                                    width: '244px',
                                    height: '45px',
                                    justifyContent: 'flex-start',
                                    paddingLeft: "20px"
                                }}
                                        size='Large'
                                        startIcon={<BadgeIcon style={{color: '#FF6600'}}/>}
                                >
                                    <CDBSidebarMenuItem>
                                        Internal CV
                                    </CDBSidebarMenuItem>
                                </Button>
                            </NavLink>

                        <NavLink
                            to="/Candidates"
                            activeClassName="activeClicked"
                            className={
                                (keycloak.hasResourceRole("hr_admin") ||
                                keycloak.hasResourceRole("client_recruiter"))
                                    ? "d-block" : "d-none"
                            }
                        >
                            <Button href="/Candidates" style={{
                                color: '#000000',
                                fontFamily: 'Michroma',
                                fontSize: '15px',
                                textTransform: 'none',
                                width: '244px',
                                height: '45px',
                                justifyContent: 'flex-start',
                                paddingLeft: "20px"
                            }}
                                    size='Large'
                                    startIcon={<PersonOutlineIcon style={{color: '#FF6600'}}/>}
                            >
                                <CDBSidebarMenuItem>
                                    Candidates
                                </CDBSidebarMenuItem>
                            </Button>
                        </NavLink>

                        <NavLink to="/JobsList" activeClassName="activeClicked"
                                 className={
                            (
                                keycloak.hasResourceRole("hr_admin") ||
                                keycloak.hasResourceRole("client_recruiter"))
                                     ? "d-block" : "d-none"
                        }
                        >
                            <Button href="/JobsList"
                                    style={{
                                        color: '#000000',
                                        fontWeight: 400,
                                        fontFamily: 'Michroma',
                                        fontSize: '15px',
                                        textTransform: 'none',
                                        width: '244px',
                                        height: '45px',
                                        justifyContent: 'flex-start',
                                        paddingLeft: "20px"
                                    }}
                                    size='Large'
                                    startIcon={<BusinessCenterOutlinedIcon style={{color: '#FF6600'}}/>}
                            >
                                <CDBSidebarMenuItem>
                                    Jobs
                                </CDBSidebarMenuItem>
                            </Button>
                        </NavLink>
                    </CDBSidebarMenu>
                </CDBSidebarContent>
            </CDBSidebar>
        </div>
    );
};

export default SideNavBar;